import React, { Component } from 'react';
// import PropTypes from "prop-types";

export class HelpPage extends Component {
  render() {
    return <div>HelpPage</div>;
  }
}

// https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
HelpPage.propTypes = {};

export default HelpPage;



// WEBPACK FOOTER //
// ./src/pages/HelpPage.js